import { parseUserIds, trim } from "./text";

const isBlank = (value) => value === undefined || value === null || value.trim() === "";

// Pure (state) => requestBody. Reads only the branch matching the active
// audience_type, so fields left over from an abandoned mode never enter the
// payload (A15) — the caller does not need to clear stale state fields for
// this guarantee to hold.
export function buildPayload(state) {
  const payload = {
    audience_type: state.audience_type,
    action_url: trim(state.action_url),
    message: trim(state.message),
    type: state.type,
    category: state.category,
  };

  if (state.audience_type === "workspace") {
    payload.audience_roles = state.audience_roles;

    const workspaceId = trim(state.workspace_id);
    if (workspaceId) {
      payload.workspace_id = workspaceId;
    }
  }

  if (state.audience_type === "user") {
    payload.user_ids = parseUserIds(state.user_ids);
  }

  if (state.send_push_notification) {
    payload.send_push_notification = true;
    payload.push_title = trim(state.push_title);

    if (!isBlank(state.push_subtitle)) {
      payload.push_subtitle = trim(state.push_subtitle);
    }
  }

  return payload;
}
